export default __webpack_public_path__ + "static/media/meta-ads.378b497f.svg";